import { useMemo } from "react";
import { useAuth } from "react-oidc-context";
import {
  isDefinitiveRenewalFailure,
  isTokenExpired,
  redirectToLogin,
  renewSession,
} from "./session.ts";

export const useAuthentication = (): {
  getToken: () => Promise<string | undefined>;
  isAuthenticated: boolean;
} => {
  const auth = useAuth();

  return useMemo(
    () => ({
      getToken: async () => {
        const user = auth.user;
        if (!user?.id_token) {
          return undefined;
        }
        if (!isTokenExpired(user)) {
          return user.id_token;
        }
        try {
          const renewedUser = await renewSession(auth);
          return renewedUser?.id_token;
        } catch (error) {
          if (isDefinitiveRenewalFailure(error)) {
            void redirectToLogin(auth);
          }
          return undefined;
        }
      },
      isAuthenticated: !!auth.user?.id_token && !isTokenExpired(auth.user),
    }),
    [auth],
  );
};
